import {EventEmitter} from "@angular/core";
import { getBoolean } from "@core/_utils/tools.utils";

export class HeaderGroup {
    grpname: string;
    desc: string;
    autogenerated: boolean;
    external: boolean;
    gr_label: string;
    userList: any;
    duplicate: boolean;

    notifyParent: EventEmitter<any> = new EventEmitter(); 

    public Clear() {
        this.grpname = ''; 
        this.autogenerated = false; 
        this.desc = '';
        this.gr_label = '';
        this.userList = [];
        this.external = false; 
        this.duplicate = false; 
    }

    public load(adata, aDataGrp){
        this.autogenerated = getBoolean(adata.gr_autogenerated);
        this.desc = adata.gr_description;
        this.grpname = adata.gr_name;
        this.userList = this.getUserList(aDataGrp);
        this.gr_label = adata.gr_label;
        this.external = adata.gr_external; 
        this.notifyParent.emit();
    }  

    public getUserList(aData) {
        let wList = [];
        aData.forEach(item => {
            wList.push(
                item.us_login,
            );            
        });
        return wList;
    }
}
